/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-10.
 * Form configuration for "aduana"
 */
import { AUTOCOMPLETE, TEXT } from '../components/data-containers/formBuilder/types';
import { COUNTRY_LIST } from '../data/selects';

export const getConfig = (actions = {}, params = {}) => {
    return {
        fields: [
            {
                fType: TEXT,
                key: 'name',
                floatingLabelFixed: true,
                floatingLabelText: 'Nombre o Razón Social',
                hintText: 'S.A de C.V.',
                fullWidth: true
            },
            {
                fType: AUTOCOMPLETE,
                key: 'executiveUser',
                tooltip: 'Ejecutivo de Ventas',
                label: 'Ejecutivo de Ventas',
                data: params.executiveUsers
            },
            {
                fType: TEXT,
                key: 'taxId',
                floatingLabelFixed: true,
                floatingLabelText: 'RFC',
                hintText: 'Identificador fiscal',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'phone1',
                floatingLabelFixed: true,
                floatingLabelText: 'Telefono 1',
                hintText: 'Número principal',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'phone2',
                floatingLabelFixed: true,
                floatingLabelText: 'Telefono 2',
                hintText: 'De contacto',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'email1',
                floatingLabelFixed: true,
                floatingLabelText: 'Correo Electronico 1',
                hintText: 'Contacto principal',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'email2',
                floatingLabelFixed: true,
                floatingLabelText: 'Correo Electronico 2',
                hintText: 'Auxiliar',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'email3',
                floatingLabelFixed: true,
                floatingLabelText: 'Correo Electronico 3',
                hintText: 'Axiliar',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'street',
                floatingLabelFixed: true,
                floatingLabelText: 'Calle',
                hintText: 'Nombre',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'externalNumber',
                floatingLabelFixed: true,
                floatingLabelText: 'Numero Exterior',
                hintText: '11A',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'internalNumber',
                floatingLabelFixed: true,
                floatingLabelText: 'Numero Interior',
                hintText: '11A',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'zipCode',
                floatingLabelFixed: true,
                floatingLabelText: 'Codigo Postal',
                hintText: '00000',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'colony',
                floatingLabelFixed: true,
                floatingLabelText: 'Colonia',
                hintText: 'Nombre',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'city',
                floatingLabelFixed: true,
                floatingLabelText: 'Ciudad',
                hintText: 'Nombre',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'municipality',
                floatingLabelFixed: true,
                floatingLabelText: 'Municipio',
                hintText: 'Nombre',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'state',
                floatingLabelFixed: true,
                floatingLabelText: 'Estado',
                hintText: 'Nombre',
                fullWidth: true
            },
            {
                fType: AUTOCOMPLETE,
                key: 'country',
                tooltip: 'País',
                label: 'País',
                hintText: 'País del domicilio',
                data: COUNTRY_LIST
            },
        ],
        rules: {
            executiveUser: [{ key: 'required', errorText: 'Campo requerido' }],
            name: [{ key: 'required', errorText: 'Indique por favor un nombre para el cliente' }],
            taxId: [{ key: 'required', errorText: 'Ingrese por favor un valor para Tax ID' }],
            phone1: [
                { key: 'required', errorText: 'Ingrese por favor un valor para el teléfono principal' },
                { key: 'onlyNumbers', errorText: 'Solo Números' },
                { key: 'validationPhone1', errorText: 'Numero telefonico tiene que ser de 10 digitos' }
            ],
            email1: [
                { key: 'required', errorText: 'Ingrese por favor un valor para el correo electronico principal' },
                { key: 'validationEmail', errorText: 'Ingrese un correo valido' }
            ],
            street: [{ key: 'required', errorText: 'Campo requerido' }],
            externalNumber: [
                { key: 'required', errorText: 'Campo requerido' }
            ],
            zipCode: [
                { key: 'required', errorText: 'Campo Requerido' },
                { key: 'validationZipCode', errorText: 'Codigo postal tiene que ser meno o igual a 10 digitos' }
            ]

        }
    };
};



// WEBPACK FOOTER //
// ./forms/cliente.js